module.exports = __webpack_public_path__ + "static/media/loving.ebada1fb.svg";